<form class="ui-search-bar" role="search" (submit)="handleSubmit($event)">
  @if (hasLabel()) {
    <label class="ui-search-bar-label" [attr.for]="inputId()">
      {{ label() }}
    </label>
  }
  <span class="ui-search-bar-control">
    <span class="ui-search-bar-search-icon" aria-hidden="true"></span>
    <input
      class="ui-search-bar-input"
      type="search"
      [id]="inputId()"
      [attr.placeholder]="placeholder()"
      [attr.aria-label]="inputAriaLabel()"
      [value]="value()"
      [disabled]="disabled()"
      (input)="handleInput($event)"
      (blur)="handleBlur()"
    />
    @if (hasActions()) {
      <span class="ui-search-bar-actions">
        @for (action of actions(); track action.id) {
          <button
            class="ui-search-bar-action"
            type="button"
            [disabled]="disabled() || action.disabled === true"
            [attr.aria-label]="action.label"
            (click)="handleActionSelected(action, $event)"
          >
            <span aria-hidden="true">
              @switch (action.id) {
                @case ('scan') {
                  <svg viewBox="0 0 24 24" focusable="false">
                    <path d="M4 7V5a1 1 0 0 1 1-1h2" />
                    <path d="M17 4h2a1 1 0 0 1 1 1v2" />
                    <path d="M20 17v2a1 1 0 0 1-1 1h-2" />
                    <path d="M7 20H5a1 1 0 0 1-1-1v-2" />
                    <path d="M7 8v8" />
                    <path d="M10 8v8" />
                    <path d="M14 8v8" />
                    <path d="M17 8v8" />
                  </svg>
                }
                @case ('mic') {
                  <svg viewBox="0 0 24 24" focusable="false">
                    <rect x="9" y="3" width="6" height="11" rx="3" />
                    <path d="M5 11a7 7 0 0 0 14 0" />
                    <path d="M12 18v3" />
                  </svg>
                }
                @case ('filters') {
                  <svg viewBox="0 0 24 24" focusable="false">
                    <path d="M4 7h10" />
                    <path d="M18 7h2" />
                    <circle cx="16" cy="7" r="2" />
                    <path d="M4 17h2" />
                    <path d="M10 17h10" />
                    <circle cx="8" cy="17" r="2" />
                  </svg>
                }
                @default {
                  {{ action.iconLabel }}
                }
              }
            </span>
          </button>
        }
      </span>
    }
  </span>
</form>
